/**
 * gateBegKuning.js — GATE sebelum Run TikTok: kad tanpa produk TikTok (2026-10-06, keputusan user).
 *
 * Latar: bila toggle "Pasang beg kuning" HIDUP (lalai), webapp menghantar `tetapan.begKuning:true`.
 * Kad tanpa link produk TikTok (cth produk import Shopee — `link` SENGAJA kosong, lihat
 * utils/shopeeImport.js) tidak boleh dipasangkan beg kuning, dan skrip TikTok (remote) mengikut
 * peraturan user 18 Sept "beg kuning gagal → simpan DRAF, jangan post": SEMUA video kad itu jadi
 * draf dengan sebab "kad ini tiada link produk TikTok". Pelanggan hanya tahu selepas larian tamat.
 *
 * Keputusan user 6 Okt: jangan ubah peraturan draf itu — letak GATE di webapp SEBELUM larian
 * bermula ("lebih menjaminkan"). Bila ada kad begini, larian DITAHAN dan pelanggan memilih:
 *   · campur (ada kad ber-link + kad tanpa link) → "Langkau N kad ini, Run yang lain", atau Batal
 *   · SEMUA kad tanpa link                       → "Post N kad ini tanpa beg kuning", atau Batal
 * ⛔ Dalam kes campur TIADA pilihan "post yang ini tanpa beg, yang lain dengan beg": `tetapan`
 *    dihantar SEKALI untuk seluruh larian (WorkspaceView → content.ts → background.ts → task),
 *    jadi niat beg kuning tidak boleh berbeza antara kad tanpa mengubah extension (ZIP).
 *
 * Fail ini = peraturan TULEN (tiada React / Firestore) — dikongsi KEDUA-DUA laluan Run TikTok
 * (kalendar + tick kad). Rupa: components/PopupGateBegKuning.jsx.
 */

/** Kad ini tiada link produk TikTok? (Takrifan SAMA dengan `linkTiktokUntukRobot` — utils/pautanProduk.js:
 *  apa yang kosong di sini = apa yang robot terima kosong.) */
export function tiadaLinkTiktok(kad) {
    return !String(kad?.link || '').trim();
}

/** Tanda pada baris popup: 'shopee' = kad ada rujukan Shopee · 'tiada' = tiada sebarang link. */
function tandaKad(kad) {
    const adaShopee = String(kad?.shopeeProductUrl || '').trim() || String(kad?.shopeeLink || '').trim();
    return adaShopee ? 'shopee' : 'tiada';
}

/**
 * Semak kad-kad dalam SATU larian TikTok.
 * @param {object[]} kadLarian  kad yang akan dijalankan (pendua id dikira sekali — laluan kalendar
 *                              boleh membawa kad yang sama untuk beberapa slot)
 * @returns {{ perlu:boolean, tiada:{id:string,nama:string,tanda:'shopee'|'tiada'}[], idTiada:Set<string>,
 *             bilLain:number, semuaTiada:boolean }}
 *          perlu = ada sekurang-kurangnya satu kad tanpa link TikTok (gate patut muncul).
 */
export function semakGateBegKuning(kadLarian) {
    const dilihat = new Set();
    const tiada = [];
    let bilLain = 0;
    for (const p of (Array.isArray(kadLarian) ? kadLarian : [])) {
        if (!p || typeof p.id !== 'string' || !p.id || dilihat.has(p.id)) continue;
        dilihat.add(p.id);
        if (tiadaLinkTiktok(p)) tiada.push({ id: p.id, nama: String(p.name || '').trim(), tanda: tandaKad(p) });
        else bilLain += 1;
    }
    return {
        perlu: tiada.length > 0,
        tiada,
        idTiada: new Set(tiada.map((k) => k.id)),
        bilLain,
        semuaTiada: tiada.length > 0 && bilLain === 0,
    };
}

/** Pilihan yang dihantar semula ke fungsi Run selepas pelanggan memilih dalam popup.
 *  `__gateBeg` = penanda: fungsi Run juga dipanggil sebagai pengendali klik (hujah pertama = event),
 *  jadi hanya objek berpenanda ini yang dibaca sebagai pilihan gate. */
export const pilihanGateLangkau = (idTiada) => ({ __gateBeg: true, langkauIds: idTiada instanceof Set ? idTiada : new Set(idTiada || []) });
export const pilihanGateTanpaBeg = () => ({ __gateBeg: true, tanpaBeg: true });
export const bacaPilihanGate = (v) => (v && typeof v === 'object' && v.__gateBeg === true ? v : null);
